import { Component } from '@angular/core';
import { StatusCardConfig } from '@shared/components/widgets/status-card/status-card-config';
import {
  DashboardService,
} from '@app/api/dmc';
import { map } from 'rxjs/operators';
import { ODataService } from '@app/core/services/odata/odata.service';
import { ODataType } from '@app/core/services/odata/types/odata-type';
import { StatusCardComponent } from '@shared/components/widgets/status-card/status-card.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-serviceydelser',
  imports: [
    StatusCardComponent,
    TranslatePipe,
  ],
  templateUrl: './dashboard-serviceydelser.component.html',
})
export class DashboardServiceydelserComponent {

  public queryDisconnect: StatusCardConfig = {
    label: 'dashboard.query.disconnect.title',
    route: ['/dashboard', 'query', 'disconnect'],
    serviceCallback: () => this.dashboardService.dashboardGetDisconnectGet(),
  };

  public queryCloseDown: StatusCardConfig = {
    label: 'dashboard.query.closedown.title',
    route: ['/dashboard', 'query', 'closedown'],
    serviceCallback: () => this.dashboardService.dashboardGetCloseDownGet(),
  };

  public queryDeliveryDisconnect: StatusCardConfig = {
    label: 'dashboard.query.deliverydisconnect.title',
    route: ['/dashboard', 'query', 'deliverydisconnect'],
    serviceCallback: () => this.dashboardService.dashboardGetDisconnectedDueToEndOfSupplyGet(),
  };

  public queryReopen: StatusCardConfig = {
    label: 'dashboard.query.reopen.title',
    route: ['/dashboard', 'query', 'reopen'],
    serviceCallback: () => this.dashboardService.dashboardGetConnectGet(),
  };

  public serviceRequestMeterControl: StatusCardConfig = {
    label: 'dashboard.servicerequest.metercontrol.title',
    route: ['/dashboard', 'query', 'metercontrol'],
    serviceCallback: () => this.oDataService.dmc
      .getCount(ODataType.meterControl, undefined, { userResponse: '2', serviceRequestCode: '5' })
      .pipe(map(count => ({ totalHitCount: count }))),
  };

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly oDataService: ODataService,
  ) {}
}
